import React, { useEffect, useRef, useState } from 'react'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Button } from '../../component/ui/button'
import { Form } from 'react-final-form'
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io'
import { Label } from '../../component/ui/label'
import { MdDelete, MdOutlineFileUpload } from 'react-icons/md'
import { getEmailTemplatesDropdown, uploadInvestorReport } from '../../utils/util'
import AdvancedDropdown from '../ui/multi-selection-dropdown-menu-with-search'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogContent, DialogDescription, DialogOverlay, DialogTitle } from '@radix-ui/react-dialog'
import { loaderSet } from '../../context/actions/loaderAction'
import { alertDanger, alertSuccess } from '../../context/actions/toastAction'
import Loader from '../loader'
import { useNavigate } from 'react-router-dom'
import { reportOptions } from '../../utils/constant'

const InvestorUploadReports = ({ forWhichUserType }) => {

  const investorDetail = [
    {
      scheme: "Option 1",
      class: "Option 1",
      name: "XYZ",
      email: "xyz@gmail.com",
      id: 123456
    },
    {
      scheme: "Option 2",
      class: "Option 1",
      name: "ABC",
      email: "ABC@gmail.com",
      id: 45678
    },
    {
      scheme: "option A",
      class: "option B",
      name: "MNO"
    }
  ]
  const allInvestorDetails = useSelector(state => state.allInvestorDetails)
  const [isLoading, setIsLoading] = useState(false)

  const [selectedClassOptions, setSelectedClassOptions] = useState([])
  const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([])
  const [selectedFrequentsOptions, setSelectedFrequentsOptions] = useState([])
  const dispatch = useDispatch()
  const allSchemeDetailsForDropdown = useSelector(state => state.allSchemeDetails);
  const navigate = useNavigate()
  const [schemeOption, setSchemeOption] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [selectedInvestor, setSelectedInvestor] = useState(null);

  // Update schemeOption whenever allSchemeDetailsForDropdown changes
  useEffect(() => {
    if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0) {
      const schemeNames = allSchemeDetailsForDropdown.map((scheme) => scheme.scheme_name);
      setSchemeOption(schemeNames);
    }
  }, [allSchemeDetailsForDropdown]);

  // Update classOption whenever allSchemeDetailsForDropdown or selectedSchemeOptions change
  useEffect(() => {
    if (allSchemeDetailsForDropdown && allSchemeDetailsForDropdown.length > 0) {
      const filteredClassOptions = allSchemeDetailsForDropdown
        .filter((scheme) =>
          scheme.scheme_name === selectedSchemeOptions[0] &&
          scheme.scheme_class !== undefined &&
          scheme.scheme_class !== null
        )
        .flatMap((scheme) => scheme.scheme_class); // Flatten nested scheme_class arrays

      setClassOption(filteredClassOptions);
    }
  }, [allSchemeDetailsForDropdown, selectedSchemeOptions]);

  console.log("Scheme Options:", schemeOption);
  console.log("Class Options:", classOption);

  const [investorList, setInvestorList] = useState([])
  useEffect(() => {
    if (allInvestorDetails && allInvestorDetails.length > 0) {
      const innerBlockInvestorList = allInvestorDetails
        .filter((investor) => {
          // Ensure that investor.schemes is an array
          if (Array.isArray(investor.schemes)) {
            // Check if any of the schemes match the selected scheme and class
            return investor.schemes.some((scheme) => {
              const schemeMatch = selectedSchemeOptions.includes(scheme.scheme_name);
              const classMatch = selectedClassOptions.includes(scheme.scheme_class);

              // Only include if both scheme and class match
              return schemeMatch && classMatch;
            });
          }
          return false; // If investor.schemes is not an array, exclude the investor
        })
        .map((investor) => {
          const matchingSchemes = investor.schemes
            .filter((scheme) => {
              const schemeMatch = selectedSchemeOptions.includes(scheme.scheme_name);
              const classMatch = selectedClassOptions.includes(scheme.scheme_class);

              return schemeMatch && classMatch;
            })
            .map((scheme) => `${scheme.folio_number}-${investor.name}`); // Create combinations

          return {
            investorName: investor.name,
            investorEmail: investor.email,
            investorId: investor.user_id,
            combinationOfPortfolioAndName: matchingSchemes, // List of matching combinations
          };
        });
      // .map((investor) =>  ({
      //   investorName:investor.name,
      //   investorEmail:investor.email,
      //   investorId:investor.user_id,
      //   combinationOfPortfolioAndName:investor.schemes.some((scheme) => {
      //     const schemeMatch = selectedSchemeOptions.includes(scheme.scheme_name);
      //     const classMatch = selectedClassOptions.includes(scheme.scheme_class);

      //     // Only include if both scheme and class match
      //     if(schemeMatch && classMatch )
      //     {

      //       return `${scheme?.portfolio_number}-${investor.name}`;
      //     }
      //     else{
      //       return null
      //     }
      //   })
      //   })); // Get the names of filtered investors
      setInvestorList(innerBlockInvestorList)
      console.log("innerBlockInvestorList", innerBlockInvestorList);
    }


    // Do something with the filtered list (innerBlockInvestorList)

  }, [selectedClassOptions, selectedSchemeOptions, allInvestorDetails]);


  const [emailTemplateOption, setEmailTemplateOption] = useState([])
  const [selectedEmailTemplateOptions, setSelectedEmailTemplateOptions] = useState([])

  useEffect(() => {
    const fetchEmailTemplatesForDropdown = async () => {
      try {
        const response = await getEmailTemplatesDropdown();
        if (response) {
          setEmailTemplateOption(response?.data.filter(emailTemplate => emailTemplate.template_name !== null).map((emailTemplate, index) => (emailTemplate.template_name)));
        }

      } catch (error) {
        console.log("Error in get email template API", error);
      }
    };

    fetchEmailTemplatesForDropdown(); // Call the async function inside useEffect
  }, []); // The empty dependency array ensures this runs only once on component mount


  const onSubmit = (e) => {
    e.preventDefault()
  }

  // Filter investors based on selected class and scheme
  const filteredInvestors = investorDetail.filter(investor => {
    const matchScheme = selectedSchemeOptions.length === 0 || selectedSchemeOptions.includes(investor.scheme);
    const matchClass = selectedClassOptions.length === 0 || selectedClassOptions.includes(investor.class);
    return matchScheme && matchClass;
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({}); // Tracks uploaded files per investor


  const fileInputRefs = useRef([]);



  const handleFileChange = (event, investor) => {
    const filesArray = Array.from(event.target.files); // Convert to array for safe storage
    setSelectedFiles(filesArray); // Store files in state without reference to `event.target.files`

    console.log("Files selected:", filesArray);

    if (filesArray.length > 0) {
      setSelectedInvestor(investor); // Store the selected investor
      setIsOpenUploadDocumentConfirmation(true); // Open the dialog box

      // Update uploadedFiles state
      // setUploadedFiles((prev) => ({
      //   ...prev,
      //   [investor?.investorId]: filesArray[0].name, // Store file name for the respective investor
      // }));
      // Clear the file input value to allow re-selection of the same file
      event.target.value = null;
    }
  };



  const handleFileUpload = async () => {
    setIsLoading(true)
    if (!selectedInvestor) {
      console.error("No investor selected.");
      return;
    }

    const payload = new FormData();
    payload.append('user_id', selectedInvestor.investorId);
    payload.append('name', selectedInvestor.investorName);
    payload.append('user_email', selectedInvestor.investorEmail);
    payload.append('scheme_name', selectedSchemeOptions);
    payload.append('class', selectedClassOptions);
    // payload.append('template_name',selectedEmailTemplateOptions);

    if (selectedFrequentsOptions) {
      payload.append('report_type', selectedFrequentsOptions && selectedFrequentsOptions.length > 0 && selectedFrequentsOptions[0] === "Quarterly" ? "quaterly" : selectedFrequentsOptions[0].toLowerCase());
    } else {
      payload.append('report_type', ''); // Add a fallback if needed
    }
    payload.append('template_name', selectedEmailTemplateOptions && selectedEmailTemplateOptions.length > 0 && selectedEmailTemplateOptions[0])
    // Append selected files
    if (!selectedFiles || selectedFiles.length === 0) {
      console.log("No files selected.");
      return;
    }

    const filesArray = Array.from(selectedFiles);
    console.log("selected files", filesArray)

    filesArray.forEach((file) => {
      payload.append('files', file);  // 'files[]' indicates that it's an array
    });
    console.log("payload", [...payload]);
    console.log("payload", filesArray);
    console.log("Uploading for Investor:", selectedInvestor);
    try {
      const response = await uploadInvestorReport(payload);
      console.log("Response:", response);
      if (response) {
        if (response?.errors && response?.errors?.length > 0) {
          dispatch(alertDanger(response?.errors[0] || "An error occurred. Please try again."));
          setIsOpenUploadDocumentConfirmation(false)
          setIsLoading(false);
          return
        }
        if (response?.code === 200) {
          dispatch(alertSuccess("Successfully upload report"))
          setIsOpenUploadDocumentConfirmation(false)
          setUploadedFiles((prev) => ({
            ...prev,
            [selectedInvestor?.investorId]: selectedFiles[0].name, // Store file name for the respective investor
          }));
          setIsLoading(false)

          return
        }
      }
      if (response && response?.code === 500) {
        dispatch(alertDanger("Issues in uploading report"))
        setIsOpenUploadDocumentConfirmation(false)
        setIsLoading(false)
      }
      if (response && response?.code === 400) {
        dispatch(alertDanger(response?.message))
        setIsOpenUploadDocumentConfirmation(false)
        setIsLoading(false)

      }
      if (response && response?.code === 404) {
        dispatch(alertDanger(response?.message))
        setIsOpenUploadDocumentConfirmation(false)
        setIsLoading(false)

      }
      // dispatch(loaderSet(false))

      else {
        dispatch(alertDanger(response?.message))
        setIsOpenUploadDocumentConfirmation(false)
        setIsLoading(false)
      }
    } catch (error) {
      console.log("Error in uploading report:", error);
      setIsLoading(false)
    }
    finally {
      // dispatch(loaderSet(false))
    }
  };




  const [isOpenUploadDocumentConfirmation, setIsOpenUploadDocumentConfirmation] = useState(false)

  const handleIsCloseUploadDocumentConfirmation = () => {
    setSelectedInvestor(null)
    setSelectedFiles([])
    // setSelectedClassOptions([])
    setIsOpenUploadDocumentConfirmation(false)
  }
  return (
    <>
      {
        isLoading && <Loader />
      }


      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="w-full flex flex-col p-6 bg-[#FFFFFF] rounded-md gap-8">
              <Button
                type="button"
                variant="outline"
                size="sm"
                className=" h-10  gap-1 text-sm w-max self-start "
                onClick={() => {
                  if (forWhichUserType === "employee") {
                    navigate("/employee")
                  }
                  if (forWhichUserType === "admin") {
                    navigate("/admin")
                  }


                }
                }
              >
                <IoIosArrowBack />
                Back
              </Button>
              <div className="flex w-full justify-between items-center gap-4">
                {/* Scheme Dropdown */}
                <div className="flex flex-col w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Scheme"
                    id="scheme"
                    options={schemeOption}
                    selectedOptions={selectedSchemeOptions}
                    setSelectedOptions={setSelectedSchemeOptions}
                    placeholder="Scheme"
                    select={"single"}
                  />
                </div>

                {/* Class Dropdown */}
                <div className="flex flex-col w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Class"
                    id="class"
                    options={classOption}
                    selectedOptions={selectedClassOptions}
                    setSelectedOptions={setSelectedClassOptions}
                    placeholder="Class"
                    select={"single"}
                    disabled={selectedSchemeOptions.length === 0 && true}
                  />
                </div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 ">

                {/* Ticker name Input field */}
                {/* Dropdown Menu */}
                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Email Template"
                    id="emailTemplate"
                    options={emailTemplateOption}
                    selectedOptions={selectedEmailTemplateOptions}
                    setSelectedOptions={setSelectedEmailTemplateOptions}
                    placeholder="Email Template"
                    select={"single"}
                  //    disabled={selectedSchemeOptions.length===0 && true}
                  />

                </div>

                <div className="flex flex-col  w-[49%] gap-2">
                  <AdvancedDropdown
                    name="Frequency"
                    id="frequents"
                    options={reportOptions}
                    selectedOptions={selectedFrequentsOptions}
                    setSelectedOptions={setSelectedFrequentsOptions}
                    placeholder="Frequency"
                    select={"single"}
                  //    disabled={selectedSchemeOptions.length===0 && true}
                  />
                </div>



              </div>
              <div className="mt-6 flex-col flex gap-2">
                {selectedFrequentsOptions && selectedFrequentsOptions.length > 0 && investorList && investorList.length > 0 ? (
                  investorList.map((investor, index) => (
                    <div key={index} className="w-full flex gap-4 items-center">
                      <div className="w-1/2 text-[#0D215C] font-bold text-lg border h-10 rounded-md border-[#3a5dd1] px-2 py-1">
                        {investor.combinationOfPortfolioAndName}
                      </div>

                      <div className="flex gap-2">
                        <input
                          type="file"
                          accept=".xls,.xlsx,.docx,.pdf"
                          ref={(el) => (fileInputRefs.current[index] = el)} // Assign each ref individually
                          style={{ display: 'none' }}
                          onChange={(event) => handleFileChange(event, investor)}
                        />
                        <span
                          onClick={() => fileInputRefs.current[index].click()} // Use the specific ref for each investor
                          className="cursor-pointer"
                          disabled={!selectedClassOptions && !selectedFrequentsOptions && !selectedSchemeOptions}
                        >
                          <MdOutlineFileUpload size={30} className="text-[#0D215C]" />
                        </span>
                        {uploadedFiles[investor.investorId] && (
                          <span className="text-green-500 text-xl font-semibold text-center">
                            {uploadedFiles[investor.investorId]}
                          </span>
                        )}
                      </div>

                      {/* <span>
              <MdDelete size={30} className="text-[#0D215C]" />
            </span> */}
                    </div>
                  ))
                ) : (
                  <div>No Investors Found</div>
                )}
              </div>
            </div>

            {/* Dialogue div for file upload confirmation  */}
            <Dialog open={isOpenUploadDocumentConfirmation} onOpenChange={handleIsCloseUploadDocumentConfirmation}>
              {/* Overlay */}
              <DialogOverlay className="fixed inset-0 bg-black bg-opacity-50 z-40" />

              {/* Dialog Content */}
              <DialogContent className="fixed inset-0 m-auto bg-white z-50 p-6 rounded-lg h-64 shadow-lg max-w-lg w-full flex flex-col justify-between">
                <div>
                  <DialogTitle className="text-lg font-bold">Upload Document Confirmation</DialogTitle>
                  <DialogDescription className="mt-2">
                    {/* Confirmation message with highlighted investor name */}
                    <p className="text-gray-700">
                      Confirm upload for <span className="font-bold text-indigo-600">{selectedInvestor?.investorName}</span>?
                    </p>

                    {/* Additional confirmation text */}
                    <p className="mt-2 text-gray-500">
                      The following document(s) will be uploaded:
                    </p>

                    {/* Display the selected files in bold and colored text */}
                    {selectedFiles && selectedFiles.length > 0 && (
                      <ul className="mt-2 list-disc list-inside">
                        {Array.from(selectedFiles).map((file, index) => (
                          <li key={index} className="text-gray-700">
                            <span className="font-semibold text-blue-600">{file.name}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </DialogDescription>

                </div>
                <div className="mt-4 flex justify-end gap-4">
                  <Button
                    type="button"
                    className="bg-red-700 text-white"
                    onClick={handleIsCloseUploadDocumentConfirmation}
                  >
                    Close
                  </Button>
                  <Button
                    type="button"
                    onClick={() => handleFileUpload()}
                    className="bg-[#0D215C] text-white"
                  >
                    Confirm Upload
                  </Button>
                </div>
              </DialogContent>
            </Dialog>


          </form>
        )}
      />
    </>
  )
}
  {/* accessiblity fix for silktide issues - H1 heading */}
  <h1 className="sr-only">Upload Reports</h1>

export default InvestorUploadReports;
